import React, { useState, useEffect } from 'react';
import './Home.css';
import Header from '../Header/Header';
import SuggestedProfiles from "../SuggestedProfiles/SuggestedProfiles";
import Search from "../Search/Search";
import Footer from '../Footer/Footer';

const Home: React.FC = () => {
    const [showSearch, setShowSearch] = useState<boolean>(false);
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSearchToggle = () => {
        setShowSearch((prev) => !prev);
    };

    return (
        <div className='body'>
            <section className='section66'>
                <Header onSearchClick={handleSearchToggle} />
            </section>

            {showSearch && (
                <section className='section77'>
                    <Search />
                </section>
            )}

            {!showSearch && (
                <section className='section1'>
                    <SuggestedProfiles />
                </section>
            )}

            {!isMobile && <Footer />}
        </div>
    );
};

export default Home;
